var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.5 21.5",
    style: {
      enableBackground: "new 0 0 21.5 21.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E2224;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,19.5c-4.8,0-8.8-3.9-8.8-8.8S5.9,2,10.8,2s8.8,3.9,8.8,8.8S15.6,19.5,10.8,19.5z M10.8,3.5 c-4,0-7.2,3.2-7.2,7.2S6.8,18,10.8,18s7.2-3.2,7.2-7.2S14.8,3.5,10.8,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,14.5c-2.1,0-3.8-1.7-3.8-3.8S8.7,7,10.8,7s3.8,1.7,3.8,3.8S12.8,14.5,10.8,14.5z M10.8,8.5 c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S12,8.5,10.8,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,11.5h-2c-0.4,0-0.8-0.3-0.8-0.8S0.3,10,0.8,10h2c0.4,0,0.8,0.3,0.8,0.8S3.2,11.5,2.8,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,11.5h-2c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h2c0.4,0,0.8,0.3,0.8,0.8S21.2,11.5,20.8,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,3.5c-0.4,0-0.8-0.3-0.8-0.8v-2C10,0.3,10.3,0,10.8,0s0.8,0.3,0.8,0.8v2C11.5,3.2,11.2,3.5,10.8,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,21.5c-0.4,0-0.8-0.3-0.8-0.8v-2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v2 C11.5,21.2,11.2,21.5,10.8,21.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsMain);
export default __webpack_public_path__ + "static/media/gps-main.d08b69cc159c817ab1b7163c28d1a4ff.svg";
export { ForwardRef as ReactComponent };